var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-breadcrumb" },
    [
      _c(
        "a-breadcrumb",
        {
          scopedSlots: _vm._u([
            {
              key: "separator",
              fn: function () {
                return [_c("span", { staticClass: "separator" })]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("span", { staticClass: "container-breadcrumb-icon" }, [
            _vm._v("当前位置:"),
          ]),
          _vm._l(_vm.list, function (item) {
            return _c(
              "a-breadcrumb-item",
              { staticClass: "ant-breadcrumb-item" },
              [_vm._v(_vm._s(item))]
            )
          }),
        ],
        2
      ),
      _vm._t("right"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }